export const SHOW_REPAYMENT_SCHEDULE_MODAL =
    'page/REPAYMENT_SCHEDULE_MODAL [show]' as const;
export const REPAYMENT_SCHEDULE_MODAL_DATA =
    'page/REPAYMENT_SCHEDULE_MODAL_DATA [done]' as const;

export const SHOW_AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL =
    'page/AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL [show]' as const;
export const AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA =
    'page/AD_HOC_AMOUNT_REPAYMENT_SCHEDULE_MODAL_DATA [done]' as const;

export const SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL =
    'page/SHOW_ACCOUNTS_SCHEDULED_REPAYMENTS_MODAL [show]' as const;

export const SHOW_SECOND_CBILS_ACCOUNT_SCHEDULED_REPAYMENTS_MODAL =
    'page/SHOW_SECOND_CBILS_ACCOUNT_SCHEDULED_REPAYMENTS_MODAL [show]' as const;
